import { BaseClient } from '../client';

interface bodyProps {
	idUsuario: number;
	senhaAntigo: string;
	senhaNova: string;
}

export const postUserPassword = async (body: bodyProps) => {
	if (process.env.NODE_ENV === 'development') {
		return 'Alterado com sucesso';
	}

	try {
		const response = await BaseClient.post<string>(`/Usuarios/UpdatePassword`, body).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
